#define PI 3.14159

varying vec3 vColor;

vec2 rotate(vec2 uv, float rotation, vec2 mid)
{
    return vec2(
        cos(rotation) * (uv.x - mid.x) + sin(rotation) * (uv.y - mid.y) + mid.x,
        cos(rotation) * (uv.y - mid.y) - sin(rotation) * (uv.x - mid.x) + mid.y
    );
}

void main()
    {
        // Square
        // gl_FragColor = vec4(vColor, 1.0);

        // Circle
        // float strength = distance(gl_PointCoord, vec2(0.5));
        // strength = step(0.2, strength);
        // strength = 1.0 - strength;
        // vec3 color = mix(vec3(0.0), vColor, strength);
        // gl_FragColor = vec4(color, 1.0);

        // Diffuse Point
        // float strength = distance(gl_PointCoord, vec2(0.5));
        // strength *= 5.0;
        // strength = 1.0 - strength;
        // vec3 color = mix(vec3(0.0), vColor, strength);
        // gl_FragColor = vec4(color, 1.0);

        // Light Point
        float strength = distance(gl_PointCoord, vec2(0.5));
        strength = 1.0 - strength;
        strength = pow(strength, 10.0);
        vec3 color = mix(vec3(0.0), vColor, strength);
        gl_FragColor = vec4(color, 1.0);

        // Light Cross Point
        // float strength = 2.0 /*brightness of core*/ / (distance(vec2(gl_PointCoord.x, (gl_PointCoord.y - 0.5) * 10.0 /*thickness of spike*/ + 0.5), vec2(0.5)) * 9.0 /*overall compactness of spike in square*/);
        // strength *= 2.0 / (distance(vec2(gl_PointCoord.y, (gl_PointCoord.x - 0.5) * 10.0 + 0.5), vec2(0.5)) * 9.0);
        // vec3 color = mix(vec3(0.0), vColor, strength);
        // gl_FragColor = vec4(color, 1.0);

        // Light Cross Point Rotated
        // vec2 rotatedUV = rotate(gl_PointCoord, PI * 0.25, vec2(0.5));
        // float strength = 0.7 /*brightness of core*/ / (distance(vec2(rotatedUV.x, (rotatedUV.y - 0.5) * 5.0 /*thinness of spike*/ + 0.5), vec2(0.5)) * 10.0 /*overall compactness of spike in square*/);
        // strength *= 0.7 / (distance(vec2(rotatedUV.y, (rotatedUV.x - 0.5) * 5.0 + 0.5), vec2(0.5)) * 10.0);
        // vec3 color = mix(vec3(0.0), vColor, strength);
        // gl_FragColor = vec4(color, 1.0);

        // sRGB Color Correction
        #include <tonemapping_fragment>
        #include <colorspace_fragment>
        
    }